import { render, staticRenderFns } from "./ReadMore.vue?vue&type=template&id=27b839c0&scoped=true"
import script from "./ReadMore.vue?vue&type=script&lang=js"
export * from "./ReadMore.vue?vue&type=script&lang=js"
import style0 from "./ReadMore.vue?vue&type=style&index=0&id=27b839c0&prod&lang=less&scoped=true"
import style1 from "./ReadMore.vue?vue&type=style&index=1&id=27b839c0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b839c0",
  null
  
)

export default component.exports